import {
  getStatusColor,
  getTransportIcon,
  SoOrder,
  OrderStatus,
} from "../utils";
import OrderCardCore, { formatDateForOrderCard } from "./OrderCardCore";
import styles from "./OrderCardCore.module.scss";

interface SoCardProps {
  order: SoOrder | null;
  status: OrderStatus;
  index?: number;
  onViewClick: () => void;
}

const SoCard = ({ order, status, index, onViewClick }: SoCardProps) => {
  if (!order) {
    return <>Not available</>;
  }

  return (
    <OrderCardCore
      status={status}
      onViewClick={onViewClick}
      title={
        <button className={styles.row}>
          {getTransportIcon(order.mode)}
          SO: {order.id}
          {index ? `/${index}` : ""}
          <span
            className={styles.circle}
            style={{ backgroundColor: getStatusColor(status) }}
          ></span>
        </button>
      }
    >
      <div className={styles.amount}>
        <span className={styles.gray}>Shipping Costs: </span> £
        {order.shippingCost}
      </div>
      <div className={styles.amount}>
        <span className={styles.gray}>Shipment Date: </span>
        {formatDateForOrderCard(order.shipmentDate)}
      </div>
      <div className={styles.amount}>
        <span className={styles.gray}>Delivery Date: </span>≈
        {formatDateForOrderCard(order.delivaryDate)}
      </div>
    </OrderCardCore>
  );
};
export default SoCard;
